export default "__VITE_ASSET__BPj0v1kC__"